// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 313 ? "85f7bc43" : chunkId) + "." + {"15":"2ffec171afdb28cd","298":"7e2be4746132d52a","313":"82aa2d9651ca8226","546":"bd8a3b15e828601c","696":"16a0ece9ee45cf3a","917":"03c5fb91e51e2b3c","962":"6646b373f69ab102","988":"578bab3e0cded52c"}[chunkId] + ".js";
};